import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MessengerLayout from "../../layout/MessengerLayout";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";

const card =
  "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022] hover:shadow-[0_0_20px_#00ff9044] transition-shadow";

export default function ManagerProfile() {
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { navigate("/login"); return; }

    fetch(`${API_BASE}/api/manager/team`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(async (res) => {
        if (!res.ok) throw new Error(`Failed (${res.status})`);
        return res.json();
      })
      .then((json) => setTeam(json?.data?.team || []))
      .catch((err) => { console.error(err); setError("Unable to load team members."); })
      .finally(() => setLoading(false));
  }, [navigate]);

  return (
    <MessengerLayout>
      <div className="p-6 text-white space-y-6">

        <div>
          <h1 className="text-2xl font-bold text-[#00ff90]">My Team</h1>
          <p className="text-white/40 text-sm mt-1">Staff members reporting to you</p>
        </div>

        {loading && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className={`${card} h-24 animate-pulse`} />
            ))}
          </div>
        )}

        {!loading && error && (
          <div className="rounded-xl border border-red-500/30 bg-red-500/10 p-4 text-sm text-red-300">{error}</div>
        )}

        {!loading && !error && team.length === 0 && (
          <div className={`${card} p-6 text-white/40`}>No team members assigned to you yet.</div>
        )}

        {!loading && !error && team.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {team.map((m) => (
              <button
                key={m.id}
                onClick={() => navigate(`/manager/employee/${m.id}`)}
                className={`${card} text-left p-5 w-full`}
              >
                <div className="flex items-center gap-4">
                  {/* Avatar */}
                  <div className="h-12 w-12 rounded-xl bg-[#00ff90]/10 border border-[#00ff90]/20 overflow-hidden flex items-center justify-center shrink-0 shadow-[0_0_10px_#00ff9022]">
                    {m.avatar ? (
                      <img src={m.avatar} alt={m.name} className="h-full w-full object-cover" />
                    ) : (
                      <span className="text-lg font-bold text-[#00ff90]">
                        {m.name?.[0]?.toUpperCase() || "?"}
                      </span>
                    )}
                  </div>

                  {/* Details */}
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-white truncate">{m.name}</p>
                    <p className="text-sm text-white/40 truncate mt-0.5">
                      {[m.role, m.department].filter(Boolean).join(" · ")}
                    </p>
                  </div>

                  {/* Status */}
                  <span className="text-xs px-2.5 py-1 rounded-full border shrink-0"
                    style={{
                      color: "#00ff90",
                      borderColor: "rgba(0,255,144,0.3)",
                      backgroundColor: "rgba(0,255,144,0.08)",
                    }}>
                    {m.status || "Active"}
                  </span>
                </div>
              </button>
            ))}
          </div>
        )}

      </div>
    </MessengerLayout>
  );
}